<template>
  <div class="page-wrap">
    <div class="page-head">
      <h1 class="h1 dTm-none">{{ $vuetify.lang.t('$vuetify.menu.todo') }}</h1>
      <button v-if="permissions.admin" class="btn-secondary btn" @click="action='add'; todoCreateOpen();">
        + {{ $vuetify.lang.t('$vuetify.add') }}
      </button>
    </div>
    <div class="page-head">
      <div class="page__sorts">
        <v-menu ref="date" v-model="menu.dates"
                :close-on-content-click="false" transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field class="search-field" :value="range.join(' ~ ')"
                          @keypress.enter="loadData()" prepend-inner-icon="$calendar"
                          :placeholder="$vuetify.lang.t('$vuetify.date')" outlined
                          hide-details v-bind="attrs" v-on="on" readonly>
            </v-text-field>
          </template>
          <v-date-picker v-model="range" no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                         show-adjacent-months
                         range @input="range.length == 2  ? menu.dates = false : menu.dates = true"
          ></v-date-picker>
        </v-menu>
        <v-autocomplete v-if="permissions.admin" v-model="filter.userprofile" clearable
                        :label="$vuetify.lang.t('$vuetify.selectWorker')"
                        :items="workers" item-text="name" item-value="id"
                        @change="loadData"
                        :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: 200,
                                      contentClass: 'select-menu select-menu--sort',
                                  }" outlined hide-details attach>
          <template v-slot:selection="{ item }">
            {{ item.name }} {{ item.lastname }},
          </template>
          <template v-slot:item="{ item }">
            {{ item.name }} {{ item.lastname }}
          </template>
        </v-autocomplete>
      </div>
    </div>
    <div class="accordions">
      <div class="cards__single" v-for="(item, date) in todo" :key="date">
        <div class="accordion__title">
          <div class="accordion__title-text h2 flex">
            {{ new Date(item.date).toLocaleDateString('ru-Ru') }}
            <template v-if="item.date_end">
              - {{ new Date(item.date_end).toLocaleDateString('ru-Ru') }}
            </template>
            <div class="useful-item__icon cp" v-if="permissions.admin"
                 @click="action='edit'; todoEditOpen(item);">
              <edit-icon/>
            </div>
            <div class="useful-item__icon cp" v-if="permissions.admin"
                 @click="deletedTodo={date: item.date, date_end: item.date_end}; confirmModal = true">
              <delete-icon/>
            </div>
          </div>
        </div>
        <div v-for="(data, obj) in item.objects" :key="obj">
          <div class="accordion__content">
            <div class="bolder todo__object">
              <div>{{ obj }}</div>
              <span class="object__divider todo__divider">-</span>
              <a target="_blank"
                 :href="'https://www.google.com/maps/search/?api=1&query='+data.object.street + '+' + data.object.house + '+' + data.object.city">
                {{ data.object.street }} {{ data.object.house }}{{
                  data.object.entrance ? data.object.entrance +
                    ' ' : ''
                }}
                {{ data.object.flat ? data.object.flat + ', ' : ', ' }}{{ data.object.index }}
                {{ data.object.city }}, {{ data.object.country }}
              </a>
              <div class="flex">
                <div class="useful-item__icon cp" v-if="permissions.admin"
                     @click="action='edit'; todoEditObjectOpen(data, item.date, item.date_end);">
                  <edit-icon/>
                </div>
                <div class="useful-item__icon cp" v-if="permissions.admin"
                     @click="deletedTodo={date: item.date, date_end: item.date_end, object: data.object.id}; confirmModal = true">
                  <delete-icon/>
                </div>
                <div class="useful-item__icon cp"
                     @click="newComment.object_id = data.object.id; addCommentModal=true">
                  <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc" focusable="false"
                       aria-hidden="true" viewBox="0 0 24 24" data-testid="AddCommentOutlinedIcon">
                    <path
                      d="M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4zm-2 13.17L18.83 16H4V4h16v13.17zM13 5h-2v4H7v2h4v4h2v-4h4V9h-4z"></path>
                  </svg>
                </div>
              </div>
            </div>
            <template v-for="task in data.data">
              <div class="todo__worker" :key="task.id.toString() + obj">
                <div class="flex">
                  <div>{{ task.time.substring(0, 5) }} -</div>
                  <div>
                    <template v-for="profile in task.user_profiles">
                      <div class="bolder" :key="task.id +'_' + profile.id">
                        {{ profile.name }} {{ profile.lastname }}
                      </div>
                    </template>
                  </div>
                </div>
                <span class="todo__divider">-</span>
                <div v-html="task.comment"></div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <v-dialog v-model="addCommentModal">
        <div class="modal todo">
          <div class="comments">
            <div class="h1">
              <span>{{ $vuetify.lang.t('$vuetify.comment') }}</span>
            </div>
            <div class="sub-title mb-3">{{ $vuetify.lang.t('$vuetify.todoComment') }}</div>
            <v-form class="comments__input" ref="comment" @submit.prevent="">
              <div class="cp" @click="clickInput">
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.39181 20.5C2.52112 20.5 1.74789 20.1506 1.07212 19.4517C0.357375 18.7126 0 17.8155 0 16.7605C0 15.7056 0.357375 14.8085 1.07212 14.0693L12.2807 1.77245C12.8525 1.16768 13.512 0.777947 14.2593 0.603238C15.0065 0.428528 15.7635 0.475565 16.5302 0.744349C17.2969 1.01313 18.0052 1.47679 18.655 2.13531C18.8629 2.36378 19.0546 2.61576 19.23 2.89126C19.4055 3.16677 19.5484 3.45571 19.6589 3.75809C19.7693 4.06048 19.8538 4.37966 19.9123 4.71564C19.9708 5.05162 20 5.3876 20 5.72358C19.974 7.14814 19.5062 8.33751 18.5965 9.29169L10.117 18.6051C10 18.7395 9.85705 18.81 9.68811 18.8167C9.51917 18.8235 9.37297 18.7663 9.24951 18.6454C9.12606 18.5244 9.06108 18.3732 9.05458 18.1918C9.04808 18.0104 9.10331 17.8525 9.22027 17.7181L17.6998 8.4047C18.3886 7.67899 18.7394 6.77856 18.7524 5.70342C18.7654 4.62828 18.434 3.74801 17.7583 3.06261C17.3424 2.61912 16.8811 2.28314 16.3743 2.05467C15.8674 1.82621 15.3216 1.75229 14.7368 1.83293C14.152 1.91356 13.6322 2.18907 13.1774 2.65944L1.96881 14.9563C1.48798 15.4536 1.24756 16.0516 1.24756 16.7505C1.24756 17.4493 1.48798 18.0473 1.96881 18.5446C2.18973 18.7731 2.43015 18.9444 2.69006 19.0586C2.94997 19.1729 3.22287 19.2166 3.50877 19.1897C4.08057 19.1628 4.61339 18.8873 5.10721 18.3632L14.0156 8.56597C14.0806 8.49878 14.1423 8.42822 14.2008 8.35431C14.2593 8.28039 14.321 8.19304 14.386 8.09224C14.4509 7.99145 14.5029 7.88393 14.5419 7.7697C14.5809 7.65547 14.6069 7.54123 14.6199 7.427C14.6329 7.31277 14.6134 7.19517 14.5614 7.07422C14.5094 6.95327 14.4314 6.83904 14.3275 6.73152C14.0806 6.46274 13.8402 6.34178 13.6062 6.36866C13.3593 6.39554 13.0799 6.56353 12.768 6.87263L6.06238 14.2508C5.98441 14.3314 5.89344 14.3885 5.78947 14.4221C5.68551 14.4557 5.5783 14.4591 5.46784 14.4322C5.35738 14.4053 5.26316 14.3516 5.18518 14.2709C5.05523 14.15 4.99025 14.0021 4.99025 13.8274C4.99025 13.6527 5.04873 13.4982 5.16569 13.3638L11.8713 5.96549C12.4042 5.42792 12.9435 5.13225 13.4893 5.0785C14.1131 5.02474 14.6849 5.26665 15.2047 5.80422C15.6985 6.30147 15.9162 6.88607 15.8577 7.55803C15.7992 8.22999 15.4841 8.86164 14.9123 9.45296L6.0039 19.2703C5.27615 20.0229 4.46394 20.4261 3.56725 20.4798C3.54126 20.4798 3.51202 20.4832 3.47953 20.4899C3.44704 20.4966 3.4178 20.5 3.39181 20.5Z"
                    fill="#ADB2B7"/>
                </svg>
              </div>
              <v-file-input class="file-input--hide" v-model="commentPhoto"
                            placeholder="Загрузить изображение (jpg, png)" id="photo" multiple
                            @change="showFile(this)" :rules="[$rules.multipleFileSize]">
              </v-file-input>
              <v-textarea v-model="newComment.text" :label="$vuetify.lang.t('$vuetify.enterText')" outlined
                          id="textarea" row-height="15" auto-grow rows="1" style="max-height: 280px"
                          append-icon="mdi-emoticon-happy-outline">
                <template v-slot:append>
                  <v-menu v-model="show_smiles" top left close-on-content-click offset-y attach>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon @click="show_smiles=!show_smiles" v-on="on" v-bind="attrs">
                        <v-icon>mdi-emoticon-happy-outline</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-text style="width: 220px">
                        <span class="cp" @click.stop="enterSmile('😀')">😀</span>
                        <span class="cp" @click.stop="enterSmile('😉')">😉</span>
                        <span class="cp" @click.stop="enterSmile('😂')">😂</span>
                        <span class="cp" @click.stop="enterSmile('😡')">😡</span>
                        <span class="cp" @click.stop="enterSmile('😱')">😱</span>
                        <span class="cp" @click.stop="enterSmile('🤨')">🤨</span>
                        <span class="cp" @click.stop="enterSmile('😍')">😍</span>
                        <span class="cp" @click.stop="enterSmile('👌')">👌</span>
                        <span class="cp" @click.stop="enterSmile('👍')">👍</span>
                        <span class="cp" @click.stop="enterSmile('👎')">👎</span>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </template>
              </v-textarea>
            </v-form>

            <div class="comments__photo flex" id="list">
              <div v-for="src in photoHtml" :key="src">
                <img :src="src" alt="photo"/>
                <button class="btn-icon" @click="deleteFile(src)">
                  <v-icon>mdi-close</v-icon>
                </button>
              </div>
              <div v-for="name in filesHtml" class="file flex" :key="name">
                <img src="../assets/img/document-preview.svg" alt="">
                <span>{{ name }}</span>
                <button class="btn-icon" @click="deleteFile(name)">
                  <v-icon>mdi-close</v-icon>
                </button>
              </div>
              <template v-if="newComment.id">
                <div v-for="doc in editingFiles" :key="doc">
                  <button class="btn-icon" @click="deleteFile(doc)">
                    <v-icon>mdi-close</v-icon>
                  </button>
                  <img
                    v-if="(['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(doc.substr(doc.lastIndexOf('.') + 1)))"
                    :src="$media_url + doc" alt="photo"/>
                  <img v-else class="document-row__photo" src="../assets/img/document-preview.svg"
                       alt="">
                </div>
              </template>
            </div>
            <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
            <div class="sign-up__buttons btn-group">
              <button class="btn btn-secondary" @click.stop="commentAddClose">
                {{ $vuetify.lang.t('$vuetify.cancel') }}
              </button>
              <button class="btn btn-primary" @click.stop="submitComment">
                {{ $vuetify.lang.t('$vuetify.save') }}
              </button>
            </div>
          </div>
        </div>
      </v-dialog>

      <v-dialog v-model="todoCreateModal" :retain-focus="false">
        <div class="modal modal-height modal-fullscreen">
          <div class="h1">
            <span v-if="action == 'add'">{{ $vuetify.lang.t('$vuetify.add') }}</span><span
            v-if="action == 'edit'">{{ $vuetify.lang.t('$vuetify.edit') }}</span>
          </div>
          <v-form ref="form" @submit.prevent="">
            <div>
              <v-menu v-model="menu.date" :close-on-content-click="false" transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="new Date(newTodo.date).toLocaleDateString('ru-Ru')"
                                :label="$vuetify.lang.t('$vuetify.date')" append-icon="$calendar" v-bind="attrs"
                                v-on="on"
                                outlined readonly :rules="[$rules.required]">
                  </v-text-field>
                </template>
                <v-date-picker v-model="newTodo.date" @input="menu.date = false" :allowed-dates="allowedDates"
                               no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                               show-adjacent-months></v-date-picker>
              </v-menu>
              <v-menu v-model="menu.dateEnd" :close-on-content-click="false" transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="newTodo.date_end ? new Date(newTodo.date_end).toLocaleDateString('ru-Ru') : ''"
                                :label="$vuetify.lang.t('$vuetify.worksEnd')" append-icon="$calendar" v-bind="attrs"
                                v-on="on" outlined readonly clearable @click:clear="newTodo.date_end=null">
                  </v-text-field>
                </template>
                <v-date-picker v-model="newTodo.date_end" @input="menu.dateEnd = false" :allowed-dates="allowedDates"
                               no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                               show-adjacent-months></v-date-picker>
              </v-menu>
              <div v-for="(object, idx) in newTodo.objects" :key="object.id">
                <div class="form__row justify-between">
                  <div class="bolder"> {{ object.name }}</div>
                  <button class="btn-icon" @click="removeObject(idx)">
                    <delete-icon/>
                  </button>
                </div>
                <div v-for="(task, i) in newTodo.objects[idx].tasks" :key="i + '_'">

                  <div class="form__row justify-between">
                    <v-autocomplete v-model="task.user_profiles" :items="workers" outlined
                                    item-text="name" item-value="id" attach multiple
                                    :menu-props="{
                              bottom: true,
                              offsetY: true,
                              maxHeight: 400,
                              contentClass: 'select-menu',
                            }">
                      <template v-slot:selection="{ item }">
                        {{ item.name }} {{ item.lastname }},
                      </template>
                      <template v-slot:item="{ item }">
                        {{ item.name }} {{ item.lastname }}
                      </template>
                    </v-autocomplete>
                    <button class="btn-icon" @click="removeTask(idx, i)">
                      <delete-icon/>
                    </button>
                  </div>
                  <button class="btn btn-secondary mb-4 btn-100" @click="changeDateOpen(newTodo.date, task, idx, i)">
                    {{ $vuetify.lang.t("$vuetify.changeDate") }}
                  </button>
                  <text-editor @change="$saveForm(action+'newTodo', newTodo)"
                        :disable-image-upload="true" :disable-media-upload="true"
                        :id="'editor'+'-'+idx+i.toString()"
                        v-model="newTodo.objects[idx].tasks[i].comment"
                    ></text-editor>
                  <v-menu :ref="'time'+'-'+idx+i.toString()" v-model="menu['time'+'-'+idx+i.toString()]"
                          :close-on-content-click="false"
                          :nudge-right="40" :return-value.sync="newTodo.objects[idx].tasks[i].time"
                          transition="scale-transition"
                          offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="newTodo.objects[idx].tasks[i].time"
                                    :label="$vuetify.lang.t('$vuetify.accounting.card.time_start')" readonly
                                    v-bind="attrs"
                                    v-on="on" outlined :rules="[$rules.required]"
                                    @change="$saveForm(action+'newTodo', newTodo)"></v-text-field>
                    </template>
                    <v-time-picker v-if="menu['time'+'-'+idx+i.toString()]"
                                   v-model="newTodo.objects[idx].tasks[i].time"
                                   full-width
                                   format="24hr"
                                   :allowed-minutes="allowedMinutes"
                                   @click:minute="$refs['time'+'-'+idx+i.toString()][0].save(newTodo.objects[idx].tasks[i].time)"></v-time-picker>
                  </v-menu>
                </div>

                <button class="btn btn-secondary mb-3" style="width: 100%" @click="addTask(idx)">
                  {{ $vuetify.lang.t('$vuetify.addTask') }}
                </button>
              </div>
              <v-autocomplete v-model="selectedObject" :items="objects" outlined
                              :placeholder="'+ ' + $vuetify.lang.t('$vuetify.addObject')" item-text="name"
                              item-value="id"
                              return-object attach
                              @change="addObject" :menu-props="{
                  bottom: true,
                  offsetY: true,
                  maxHeight: 400,
                  contentClass: 'select-menu',
                }"></v-autocomplete>
              <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
            </div>
            <div class="sign-up__buttons btn-group">
              <button class="btn btn-secondary" @click.stop="todoCreateClose">
                {{ $vuetify.lang.t('$vuetify.cancel') }}
              </button>
              <button class="btn btn-primary" @click.stop="addTodo">
                {{ $vuetify.lang.t('$vuetify.save') }}
              </button>
            </div>
          </v-form>
        </div>
      </v-dialog>

      <v-dialog v-model="changeDateModal">
        <div class="modal todo">
          <div class="h1">
            <span>{{ $vuetify.lang.t('$vuetify.changeDate') }}</span>
          </div>
          <v-form ref="formDate" @submit.prevent="">
            <v-menu v-model="menu.dateChange" :close-on-content-click="false" transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :value="new Date(changingTask.date).toLocaleDateString('ru-Ru')"
                              :label="$vuetify.lang.t('$vuetify.date')" append-icon="$calendar" v-bind="attrs"
                              v-on="on"
                              outlined readonly :rules="[$rules.required]">
                </v-text-field>
              </template>
              <v-date-picker v-model="changingTask.date" @input="menu.dateChange = false" :allowed-dates="allowedDates"
                             no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                             show-adjacent-months></v-date-picker>
            </v-menu>
            <div class="sign-up__buttons btn-group">
              <button class="btn btn-secondary" @click.stop="changeDateModal=false">
                {{ $vuetify.lang.t('$vuetify.cancel') }}
              </button>
              <button class="btn btn-primary" @click.stop="changeDate">
                {{ $vuetify.lang.t('$vuetify.save') }}
              </button>
            </div>
          </v-form>
        </div>
      </v-dialog>


      <ConfirmModal v-model="confirmModal" @confirm="deleteTodo">
        <span v-if="alertError">{{ alertMsg }}</span>
      </ConfirmModal>

      <SpinnerLoader :overlay="loader"></SpinnerLoader>
    </div>
  </div>
</template>

<script>
import SpinnerLoader from "@/components/SpinnerLoader";
import ConfirmModal from "@/components/confirmModal";
import DeleteIcon from "@/components/icons/DeleteIcon";
import EditIcon from "@/components/icons/EditIcon";
import {mapGetters} from "vuex";
import TextEditor from "@/views/TextEditor.vue";

export default {
  name: "TodoList",
  components: {TextEditor, EditIcon, DeleteIcon, ConfirmModal, SpinnerLoader},

  props: {
    object: [String, Number],
  },

  data: function () {
    return {
      range: [],
      filter: {
        userprofile: ''
      },

      todo: [],
      objects: [],
      workers: [],

      action: '',
      newTodo: {
        date: new Date().toISOString().substring(0, 10),
        objects: [],
      },
      deleted: [],
      selectedObject: null,
      selectedWorker: [],
      selectedSubworker: null,
      todoCreateModal: false,
      confirmModal: false,
      deletedTodo: null,
      menu: {
        date: false,
        dateEnd: false,
        time: [],
        dateChange: false,
      },
      alertError: false,
      alertMsg: "",
      loader: false,
      form_loader: false,

      newComment: {
        text: "",
        files: []
      },
      commentPhoto: [],
      commentPhotoRow: [],
      photoHtml: [],
      filesHtml: [],
      show_smiles: false,
      addCommentModal: false,
      changeDateModal: false,
      changingTask: 0,
    }
  },

  watch: {
    range: function () {
      if (this.range.length == 2)
        this.loadData()
    },
    'newTodo.objects': {
      deep: true,
      handler() {
        this.$saveForm(this.action + 'newTodo', this.newTodo)
      },
    },
    commentPhotoRow() {
      if (
        this.commentPhoto.length == this.commentPhotoRow.length &&
        this.commentPhotoRow.length
      ) {
        this.addComment();
      }
    },
  },

  created: function () {
    if (this.object) {
      this.range = [
        new Date(new Date().setDate(1)).toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ]
    }
    this.loadData()

// Создание экземпляра MutationObserver для отслеживания изменений в DOM
    const observer = new MutationObserver((mutations) => {
      // Проверка, имеются ли мутации добавления или удаления узлов
      const shouldUpdate = mutations.some(mutation => mutation.addedNodes.length);
      if (shouldUpdate) {
        this.updateButtons(); // Вызов функции обновления кнопок при каждом изменении в DOM
      }
    });

// Настройка конфигурации наблюдателя: отслеживать только добавление или удаление дочерних элементов
    const config = {childList: true, subtree: true};

// Начало наблюдения за всем DOM документа
    observer.observe(document.body, config);
  },

  methods: {
    allowedDates: val => val >= new Date(new Date().setDate(new Date().getDate() - 1)).toISOString(),
    allowedMinutes: v => v % 5 == 0,

    updateButtons() {
      setTimeout(500)
      let btns = document.querySelectorAll('.v-date-picker-table--date .v-btn--disabled.v-btn');
      for (let i = 0; i < btns.length; i++) {
        btns[i].removeAttribute('disabled'); // Удаление атрибута disabled
        btns[i].classList.remove('v-btn--disabled'); // Удаление класса v-btn--disabled
        btns[i].classList.add('v-btn--seems-disabled');
      }
    },

    loadData: function () {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/todo",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          range: JSON.stringify(this.range),
          object: this.object ? this.object : null,
          filter: JSON.stringify(this.filter)
        },
      }).then((response) => {
        if (response.data.data.data) {
          this.todo = response.data.data.data;
        }
        if (this.permissions.admin) {
          this.loadObjects()
          this.loadWorkers()
        }
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).then(() => {
        this.loader = false
      })
    },
    loadObjects() {
      this.$axios({
        url: this.$hostname + "time-tracking/accounting/objects",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        }
      }).then((response) => {
        this.objects = response.data.data.data
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadWorkers() {
      this.$axios({
        url: this.$hostname + "time-tracking/profiles/active",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          this.workers = response.data.data.data;
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },

    addTodo() {
      if (this.$refs.form.validate()) {
        let items = []
        this.newTodo.objects.forEach(o => {
          o.tasks.forEach(t => {
            items.push({
              date: this.newTodo.date,
              date_end: this.newTodo.date_end,
              object: o.id,
              user_profiles: t.user_profiles,
              time: t.time,
              comment: t.comment,
              id: t.id ?? 0,
              done: false
            })
          })
        })
        if (this.action == 'edit') {
          this.editTodo(items)
        } else {
          this.$axios({
            url: this.$hostname + "time-tracking/todo",
            method: "POST",
            headers: {
              Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
              "Content-Type": "multipart/form-data",
            },
            data: {items: JSON.stringify(items)},
          }).then(() => {
            this.loadData()
            this.todoCreateClose()
          }).catch((response) => {
            this.alertMsg = this.$catch(response)
            this.alertError = true
          })
        }
      } else {
        this.alertMsg = this.$vuetify.lang.t('$vuetify.fillForm')
        this.alertError = true
      }
    },
    editTodo(items) {
      this.$axios({
        url: this.$hostname + "time-tracking/todo",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          items: JSON.stringify(items),
          deleted: JSON.stringify(this.deleted)
        },
      }).then(() => {
        this.loadData()
        this.todoCreateClose()
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    deleteTodo() {
      this.$axios({
        url: this.$hostname + "time-tracking/todo",
        method: "DELETE",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {date: this.deletedTodo.date, date_end: this.deletedTodo.date_end, object: this.deletedTodo.object},
      }).then(() => {
        this.loadData()
        this.deletedTodo = {}
        this.confirmModal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    addObject() {
      if (!this.newTodo.objects)
        this.newTodo.objects = []
      if (this.newTodo.objects.indexOf(this.selectedObject) == -1) {
        let object = this.selectedObject
        object.selectedWorker = false
        object.tasks = []
        this.newTodo.objects.push(object)
      }
      this.selectedObject = {}
    },
    removeObject(idx) {
      if (this.action == 'edit') {
        if (this.newTodo.objects[idx].tasks != undefined && this.newTodo.objects[idx].tasks.length != 0) {
          this.newTodo.objects[idx].tasks.forEach(w => {
            if (w.id != 0)
              this.deleted.push(w.todo)
          })
        }
      }
      this.newTodo.objects.splice(idx, 1)
    },
    addTask(idx) {
      this.newTodo.objects[idx].tasks.push({
        comment: '',
        time: '',
        user_profiles: [],
      });
      this.$forceUpdate()
    },
    removeTask(idx, i) {
      if (this.action == 'edit') {
        this.deleted.push(this.newTodo.objects[idx].tasks[i].id)
      }
      this.newTodo.objects[idx].tasks.splice(i, 1);
      this.$forceUpdate()
    },
    changeDateOpen(date, task, idx, i) {
      this.changeDateModal = true
      this.changingTask = task
      this.changingTask.date = date
      this.changingTask.idx = idx
      this.changingTask.i = i
    },
    changeDate() {
      if (this.$refs.form.validate() && this.$refs.formDate.validate()) {
        this.$axios({
          url: this.$hostname + "time-tracking/todo",
          method: "PUT",
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: {
            items: JSON.stringify([this.changingTask])
          },
        }).then(() => {
          this.changeDateModal = false
          this.newTodo.objects[this.changingTask.idx].tasks.splice(this.changingTask.i, 1);
          this.$forceUpdate()
          this.loadData()
        }).catch((response) => {
          this.alertMsg = this.$catch(response)
          this.alertError = true
        })
      }
    },
    todoCreateOpen() {
      this.todoCreateModal = true
      let form = this.$loadForm(this.action + 'newTodo')
      if (form.objects && form.objects.length)
        this.newTodo = form
      else {
        this.newTodo = {
          date: new Date().toISOString().substring(0, 10),
          objects: [],
        }
      }
    },
    todoEditOpen(items) {
      let form = this.$loadForm(this.action + 'newTodo')
      if (form.objects && form.objects.length && form.date == items.date && form.date_end == items.date_end)
        this.newTodo = form
      else {
        this.newTodo.date = items.date
        this.newTodo.date_end = items.date_end
        this.deleted = []
        let objects = []
        for (let obj in items.objects) {
          objects.push(items.objects[obj].object)
        }
        this.newTodo.objects = objects
        this.newTodo.objects.forEach(obj => {
          obj.tasks = []
          items.objects[obj.name].data.forEach(line => {
            obj.tasks.push({})
            obj.tasks[obj.tasks.length - 1].comment = line.comment
            obj.tasks[obj.tasks.length - 1].time = line.time
            obj.tasks[obj.tasks.length - 1].id = line.id
            obj.tasks[obj.tasks.length - 1].user_profiles = line.user_profiles.map((item) => item.id);
          })
        })
      }
      this.todoCreateModal = true
    },
    todoEditObjectOpen(data, date, date_end) {
      this.newTodo.date = date
      this.newTodo.date_end = date_end
      this.deleted = []
      this.newTodo.objects = [data.object]
      this.newTodo.objects[0].tasks = []
      data.data.forEach(line => {
        this.newTodo.objects[0].tasks.push({})
        this.newTodo.objects[0].tasks[this.newTodo.objects[0].tasks.length - 1].comment = line.comment
        this.newTodo.objects[0].tasks[this.newTodo.objects[0].tasks.length - 1].time = line.time
        this.newTodo.objects[0].tasks[this.newTodo.objects[0].tasks.length - 1].id = line.id
        this.newTodo.objects[0].tasks[this.newTodo.objects[0].tasks.length - 1].user_profiles = line.user_profiles.map((item) => item.id);
      })
      this.todoCreateModal = true
    },
    todoCreateClose() {
      this.newTodo = {
        date: new Date().toISOString().substring(0, 10),
        objects: [],
      }
      this.$clearForm(this.action + 'newTodo')
      this.todoCreateModal = false
      this.alertError = false
    },


    addComment() {
      this.newComment.files = JSON.stringify(this.commentPhotoRow)
      this.$axios({
        url: this.$hostname + "time-tracking/objects/comments",
        method: "POST",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          text: this.newComment.text,
          files: this.newComment.files,
          object_comments_id: null,
          objects_id: this.newComment.object_id,
        },
      })
        .then(() => {
          this.commentAddClose()
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    uploadFile(file) {
      this.$axios({
        url: this.$hostname + "time-tracking/images/upload/objects",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: {
          file: file,
        },
      })
        .then((response) => {
          this.commentPhotoRow.push(response.data.data)
        })
        .catch((error) => {
          alert("Ошибка загрузки файла: " + error.message);
        });
    },
    submitComment() {
      if (this.$refs.comment.validate()) {
        if (this.commentPhoto.length)
          this.commentPhoto.forEach((photo) => {
            this.uploadFile(photo);
          });
        else this.addComment();
      } else {
        this.alertMsg = "Слишком большой файл"
        this.alertError = true
      }
    },
    enterSmile(smile) {
      this.newComment.text += smile
      this.show_smiles = false
    },
    clickInput() {
      document.getElementById("photo").click();
    },
    // eslint-disable-next-line no-cond-assign,no-unused-vars
    showFile(e) {
      var files = this.commentPhoto;
      this.filesHtml = [];
      this.photoHtml = [];
      // eslint-disable-next-line no-cond-assign
      for (var i = 0, f; (f = files[i]); i++) {
        if (!f.type.match("image.*")) {
          this.filesHtml.push(f.name)
        } else {


          var fr = new FileReader();
          // eslint-disable-next-line no-cond-assign,no-unused-vars
          fr.onload = ((theFile) => {
            return (e) => {
              this.photoHtml.push(e.target.result);
            };
          })(f);


          fr.readAsDataURL(f);
        }
      }
    },
    commentAddClose() {
      this.newComment = {
        text: "",
        files: [],
      };
      this.commentPhoto = [];
      this.commentPhotoRow = [];
      this.photoHtml = [];
      this.filesHtml = [];
      this.addCommentModal = false
    },
    deleteFile(file) {
      if (this.newComment.id) {
        let idx = this.newComment.files.findIndex(doc => {
          return doc == file
        })
        if (idx !== -1) {
          this.deletedFiles.push(file)
          this.newComment.files.splice(idx, 1)
        }
      }
      idx = this.commentPhoto.findIndex(f => {
        if (!f.type.match("image.*")) {
          return f.name == file
        } else {
          var fr = new FileReader();
          // eslint-disable-next-line no-cond-assign,no-unused-vars
          fr.onload = ((theFile) => {
            return (e) => {
              this.photoHtml.push(e.target.result);
            };
          })(f);
          return fr == file
        }
      })
      if (idx > -1) {
        this.commentPhoto.splice(idx, 1)
      }
      let idx = this.photoHtml.findIndex(doc => {
        return doc == file
      })
      if (idx > -1) {
        this.photoHtml.splice(idx, 1)
      }
      idx = this.filesHtml.findIndex(doc => {
        return doc == file
      })
      if (idx > -1) {
        this.filesHtml.splice(idx, 1)
      }
    },

  },

  computed: {
    ...mapGetters(['permissions']),
  }
}
</script>

<style scoped>

</style>